import React, { useEffect, useState } from 'react';
import { SlIcon, SlInput } from '@shoelace-style/shoelace/dist/react';
import { Link } from 'react-router-dom';
import { searchMountainByName } from '../utils/moutainDetails';
import { MountainSearchStyles } from './mountain-search.styles';
import { useTranslation } from 'react-i18next';

const MountainSearch = () => {
  const { t } = useTranslation('app');
  const [search, setSearch] = useState();
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (search && search?.length >= 2) {
      setResults(searchMountainByName(search));
    } else {
      setResults([]);
    }
  }, [search]);

  return (
    <MountainSearchStyles>
      <div
        className={'explain'}
        dangerouslySetInnerHTML={{ __html: t('search.explain') }}
      />

      <div style={{ height: '1rem' }}></div>

      <SlInput
        // placeholder={t('search.searchMountain')}
        clearable
        onSlInput={(e) => setSearch(e.target.value)}
      >
        <SlIcon name="search" slot="prefix"></SlIcon>
      </SlInput>

      {results.slice(0, 10).map((mountain, i) => (
        <Link
          className={'mountain-item'}
          key={i}
          to={`/glaciers/${mountain.id}`}
        >
          {mountain.name}
        </Link>
      ))}
    </MountainSearchStyles>
  );
};

export default MountainSearch;
